import Vue from 'vue';
import VueResource from "vue-resource";
import Moment from "vue-moment";
import Print from 'vue-print-nb'
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import {createPinia, PiniaVuePlugin} from 'pinia';

export function setupPlugins() {
    // Vue Resource
    Vue.use(VueResource);

    // Vue Moment
    Vue.use(Moment);

    // Vue Print
    Vue.use(Print);

    // SweetAlert2
    Vue.use(VueSweetalert2);
    window.swal = Vue.swal;

    // Pinia
    Vue.use(PiniaVuePlugin);
    const pinia = createPinia();

    return { pinia };
}